var Header = require('./header');
var Alert = require('./alert');
var Select = require('./qjzxSelect');
var Ask = require('./qjzxAsk');
var Answer = require('./qjzxAnswer');
var Anli = require('./qjzxAnli');
module.exports = san.defineComponent({
    template: require('../views/app.html'),
    initData: function () {
        return {
            listType: 2,
            showType: 0,
            cortShow: false,
            touchFlag: true,
            askType: '',
            type: '',
            title: '智能情景咨询',
            subTitle: '返回',
            configInfo: {},
            businessType: -1,
            showCompany: false,
            noLogo: false
        };
    },
    components: {
        'header': Header,
        'alert': Alert,
        'select': Select,
        'ask': Ask,
        'answer': Answer,
        'anli': Anli
    },
    created: function () {
        var me = this;
        if (!!sessionStorage.safeInfo) { } else {
            $.ajax({
                url: '/api/websafe/safeInfo?domainName=' + document.domain.slice(0, 20),
                type: 'get',
                dataType: 'json',
                contentType: 'application/json',
                data: null,
                success: function (response) {
                    sessionStorage.safeInfo = response.safeInfo;
                },
                error: function (err) {

                }
            });
        }
        setTimeout(function () {
            me.ref('header').setTitle('法律咨询意见书', '');
            $.ajax({
                url: window.Apipath.getBg(),
                dataType: 'json',
                success: function (resp) {
                    var find = false;
                    resp.forEach(function (item) {
                        if (item.domain == document.domain) {
                            if(item.noLogo) {
                              me.data.set('noLogo', true);
                            }
                            if (item.type === 'heilongjiang') {
                                find = true;
                            }
                            $('.home').addClass(item.img);
                            san.nextTick(function () {
                                me.data.set('type', item.type);
                            })
                        }
                    })
                    if (!find) {
                        me.ref('select').showCompany();
                        me.ref('answer').showCompany();
                        me.ref('anli').showCompany();
                        me.ref('ask').showCompany();
                        me.data.set('showCompany', true);
                    }
                },
                error: function (err) {
                    console.log(err.msg);
                }
            });
        }, 0);
    },
    messages: {
        getAskType: function (obj) {
            var params = obj.value;
            this.data.set('title', params.title);
            this.data.set('askType', params.t);
            this.data.set('showType', 1);
            var me = this;
            setTimeout(function () {
                san.nextTick(function () {
                    me.ref('header').setTitle(params.title, me.data.get('subTitle'));
                    me.ref('ask').getQType(params);
                });
            }, 100);
            document.body.scrollTop = document.documentElement.scrollTop = 0
        },
        back: function () {
            var me = this;
            switch (this.data.get('listType')) {
                case 2:
                    if (this.data.get('showType') === 1) {
                        this.data.set('showType', 0);
                        this.ref('header').setTitle('智能情景咨询', '');
                    }
                    break;
                case 3:
                    this.data.set('listType', 2);
                    this.ref('header').setTitle(this.data.get('title'), this.data.get('subTitle'));
                    break;
                case 4:
                    this.data.set('listType', 3);
                    break;
            }
            me.nextTick(function () {
                window.Tool._scroll(me.ref('scroll'), 30000);
            });
        },
        switchType: function (t) {
            this.data.set('businessType', t);
            this.data.set('listType', 1);
        },
        switchChild: function (str) {
            this.data.set('businessType', str);
        },
        switchListType: function (params) {
            this.data.set('listType', 3);
            var me = this;
            san.nextTick(function () {
                me.ref('header').setTitle('', me.data.get('subTitle'));
                me.ref('answer').getBgAnswer(params, me.data.get('askType'));
            })
        },
        getCase: function (caseName) {
            this.data.set('listType', 4);
            var me = this;
            san.nextTick(function () {
              console.log(me.data)
                me.ref('header').setTitle('', me.data.get('subTitle'));
                me.ref('anli').getAnli(caseName);
            });
        },
        goCount: function (n) {
            this.data.set('listType', 2);
            this.data.set('businessType', n);
        },
        toQjzx: function () {
            this.data.set('listType', 2);
            this.data.set('showType', 0);
        },
        toScroll: function (top) {
            window.Tool._scroll(this.ref('scroll'), top.value);
        },
        showAlert: function (obj) {
            var params = obj.value;
            this.ref('alert').show(params.title, params.msg)
        }
    }
});




//////////////////
// WEBPACK FOOTER
// ./src/components/app.js
// module id = 355
// module chunks = 1